import { Component } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'where-to-buy',
  templateUrl: './where-to-buy.component.html',
  styleUrl: './where-to-buy.component.scss',
  standalone: false,
})
export class WhereToBuyComponent {
  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  constructor(private currentProductService: CurrentProductService) {}
}
